import { Card, Flex, QRCode, Typography } from "antd"
import React from "react"

const { Text, Title } = Typography

export function SettingsWhatsapp() {
  const whatsappBotUrl = import.meta.env.VITE_APP_WHATSAPP_BOT_URL

  if (!whatsappBotUrl) return

  return (
    <Card>
      <Flex vertical gap={"small"}>
        <Title level={5} className={"text-primary mb-0"}>
          Connect your WhatsApp
        </Title>
        <Flex vertical>
          <Text className={"text-xs"}>
            Scan this QR code using WhatsApp to receive EZBuild alerts.
          </Text>
          <Text className={"text-xs"}>
            WhatsApp → Settings → Linked Devices → Link a device.
          </Text>
        </Flex>
        <Flex justify={"center"}>
          <QRCode
            value={whatsappBotUrl}
            size={128}
            errorLevel="M"
            color="#000000"
            bgColor="#ffffff"
          />
        </Flex>
        <Text type={"secondary"} className={"text-xs"}>
          You can revoke access anytime in WhatsApp {">"} Linked Devices.
        </Text>
      </Flex>
    </Card>
  )
}
